export const translations = {
  'zh-CN': {
    displayComponents: '显示组件',
    slogan: '标语',
    clock: '时钟',
    search: '搜索',
    ai: 'AI助手',
    quickDial: '快捷拨号',
    todo: '待办事项',
    backgroundSettings: '背景设置',
    defaultStyle: '默认风格',
    techRing: '科技光环',
    matrixGrid: '矩阵网格',
    dynamicRays: '动态射线',
    flowLight: '流光溢彩',
    customImage: '自定义图片 URL / 上传',
    uploadLocal: '上传本地图片',
    recommendWallpaper: '推荐壁纸',
    theme: '主题',
    skin: '皮肤',
    settings: '设置',
    searchPlaceholder: '发现美好世界...',
    aiSource: 'AI助手数据源',
    quickDialSource: '快捷拨号数据源',
    defaultSource: '默认列表',
    manage: '管理',
    importBookmarks: '导入书签',
    exportBookmarks: '导出书签',
    recommendedHome: '推荐首页'
  },
  'zh-TW': {
    displayComponents: '顯示組件',
    clock: '時鐘',
    search: '搜尋',
    ai: 'AI助手',
    quickDial: '快速撥號',
    todo: '待辦事項',
    backgroundSettings: '背景設置',
    defaultStyle: '默認風格',
    techRing: '科技光環',
    matrixGrid: '矩陣網格',
    dynamicRays: '動態射線',
    flowLight: '流光溢彩',
    customImage: '自定義圖片 URL / 上傳',
    uploadLocal: '上傳本地圖片',
    recommendWallpaper: '推薦壁紙',
    theme: '主題',
    skin: '皮膚',
    settings: '設置',
    searchPlaceholder: '搜尋...',
    aiSource: 'AI助手數據源',
    quickDialSource: '快速撥號數據源',
    defaultSource: '默認列表',
    manage: '管理',
    importBookmarks: '導入書籤',
    exportBookmarks: '導出書籤'
  },
  'en': {
    displayComponents: 'Display Components',
    slogan: 'Slogan',
    clock: 'Clock',
    search: 'Search',
    ai: 'AI Assistant',
    quickDial: 'Quick Dial',
    todo: 'To-Do',
    backgroundSettings: 'Background Settings',
    defaultStyle: 'Default Style',
    techRing: 'Tech Ring',
    matrixGrid: 'Matrix Grid',
    dynamicRays: 'Dynamic Rays',
    flowLight: 'Flow Light',
    customImage: 'Custom Image URL / Upload',
    uploadLocal: 'Upload Local Image',
    recommendWallpaper: 'Recommended',
    theme: 'Theme',
    skin: 'Skin',
    settings: 'Settings',
    searchPlaceholder: 'Search anything...',
    aiSource: 'AI Source',
    quickDialSource: 'Quick Dial Source',
    defaultSource: 'Default List',
    manage: 'Manage',
    importBookmarks: 'Import Bookmarks',
    exportBookmarks: 'Export Bookmarks'
  },
  'ko': {
    displayComponents: '구성 요소 표시',
    clock: '시계',
    search: '검색',
    ai: 'AI 비서',
    quickDial: '단축 다이얼',
    todo: '할 일',
    backgroundSettings: '배경 설정',
    defaultStyle: '기본 스타일',
    techRing: '테크 링',
    matrixGrid: '매트릭스 그리드',
    dynamicRays: '다이내믹 레이',
    flowLight: '플로우 라이트',
    customImage: '사용자 지정 이미지 URL / 업로드',
    uploadLocal: '로컬 이미지 업로드',
    recommendWallpaper: '추천 배경화면',
    theme: '테마',
    skin: '스킨',
    settings: '설정',
    searchPlaceholder: '검색...',
    aiSource: 'AI 소스',
    quickDialSource: '단축 다이얼 소스',
    defaultSource: '기본 목록',
    manage: '관리',
    importBookmarks: '북마크 가져오기',
    exportBookmarks: '북마크 내보내기'
  },
  'ja': {
    displayComponents: 'コンポーネント表示',
    clock: '時計',
    search: '検索',
    ai: 'AIアシスタント',
    quickDial: 'スピードダイヤル',
    todo: 'To-Do',
    backgroundSettings: '背景設定',
    defaultStyle: 'デフォルトスタイル',
    techRing: 'テックリング',
    matrixGrid: 'マトリックスグリッド',
    dynamicRays: 'ダイナミックレイ',
    flowLight: 'フローライト',
    customImage: 'カスタム画像 URL / アップロード',
    uploadLocal: 'ローカル画像をアップロード',
    recommendWallpaper: 'おすすめ壁紙',
    theme: 'テーマ',
    skin: 'スキン',
    settings: '設定',
    searchPlaceholder: '検索...',
    aiSource: 'AIソース',
    quickDialSource: 'スピードダイヤルソース',
    defaultSource: 'デフォルトリスト',
    manage: '管理',
    importBookmarks: 'ブックマークをインポート',
    exportBookmarks: 'ブックマークをエクスポート'
  },
  'ar': {
    displayComponents: 'عناصر العرض',
    clock: 'ساعة',
    search: 'بحث',
    ai: 'مساعد الذكاء الاصطناعي',
    quickDial: 'الاتصال السريع',
    todo: 'المهام',
    backgroundSettings: 'إعدادات الخلفية',
    defaultStyle: 'النمط الافتراضي',
    techRing: 'حلقة تقنية',
    matrixGrid: 'شبكة مصفوفة',
    dynamicRays: 'أشعة ديناميكية',
    flowLight: 'ضوء متدفق',
    customImage: 'رابط صورة مخصص / تحميل',
    uploadLocal: 'تحميل صورة محلية',
    recommendWallpaper: 'خلفيات موصى بها',
    theme: 'موضوع',
    skin: 'مظهر',
    settings: 'إعدادات',
    searchPlaceholder: 'بحث...',
    aiSource: 'مصدر الذكاء الاصطناعي',
    quickDialSource: 'مصدر الاتصال السريع',
    defaultSource: 'القائمة الافتراضية',
    manage: 'إدارة',
    importBookmarks: 'استيراد الإشارات المرجعية',
    exportBookmarks: 'تصدير الإشارات المرجعية'
  }
};

export type Language = keyof typeof translations;
